import cx from 'classnames';
import React, { useCallback } from 'react';
import ItemTypes from '../ItemTypes';
import FormElementWrapper from '../components/FormElementWrapper';
import { mapItemTypeToBaseFormElement } from '../defaults/baseFormElements';
import Dubstin from '../multi-column/dustbin';
import { ItemsTypes } from '../toolbar';

const ThreeColumnLayout = props => {
  const {
    seq,
    index,
    registers,
    isBuilder,
    moveCard,
    setAsChild,
    editModeOn,
    removeChild,
    getDataById,
    onChange,
    onBulkManipulation,
    getItemValueById,
    onUpdateElement,
    onUpdateMultipleElements,
    onAddItem,
    onToggleEditing,
    editing,
    readOnly,
    disabled,
    onDelete,
    collapseThreeColumnFileUploadLayout,
  } = props;

  const childItems = props.data.childItems || [];
  const shouldCollapseFileUploadLayout =
    !isBuilder &&
    collapseThreeColumnFileUploadLayout &&
    childItems.length === 3 &&
    childItems.every(id => getDataById(id)?.type === ItemsTypes.FileUpload);
  const getElement = useCallback(
    id => {
      const item = getDataById(id);
      const itemValue = getItemValueById(id);
      const Element = mapItemTypeToBaseFormElement[item?.type];

      if (Element) {
        return (
          <Element
            editing={editing}
            data={item}
            registers={registers}
            value={
              item.type === ItemsTypes.FileUpload ? itemValue?.map(x => x?.value) : itemValue?.value
            }
            itemValue={itemValue}
            onChange={onChange}
            readOnly={readOnly}
            disabled={disabled}
            onDelete={onDelete}
          />
        );
      }
    },
    [getDataById, getItemValueById, onChange, registers, editing, readOnly, disabled, onDelete],
  );

  return (
    <FormElementWrapper {...props}>
      <div
        className={cx('grid print:gap-8', {
          'print:[grid-template-columns:1fr_1fr_1fr]': shouldCollapseFileUploadLayout,
          'gap-8': !shouldCollapseFileUploadLayout,
        })}
        style={{
          gridTemplateColumns: shouldCollapseFileUploadLayout ? undefined : '1fr 1fr 1fr',
        }}
      >
        {props.data.childItems.map((id, i) => (
          <div
            className={cx({
              'border rounded-lg border-[#E3E3E3]': isBuilder && !id,
            })}
            key={i}
          >
            {isBuilder ? (
              <Dubstin
                isBuilder={isBuilder}
                style={{
                  width: '100%',
                  // height: '100%', // ToDo: change to h-auto
                  border: 'none',
                  minHeight: 100,
                }}
                data={props.data}
                accepts={[ItemTypes.BOX, ItemTypes.CARD]}
                items={props.data.childItems}
                col={i}
                parentIndex={index}
                editModeOn={editModeOn}
                id={props.data.id}
                moveCard={moveCard}
                onAddItem={onAddItem}
                onUpdateElement={onUpdateElement}
                onBulkManipulation={onBulkManipulation}
                onUpdateMultipleElements={onUpdateMultipleElements}
                index={index}
                _onDestroy={() => removeChild(props.data, i)}
                getDataById={getDataById}
                setAsChild={setAsChild}
                registers={registers}
                seq={seq}
                onToggleEditing={onToggleEditing}
              />
            ) : (
              getElement(id)
            )}
          </div>
        ))}

        {isBuilder && (
          <>
            <div
              className="absolute h-full border-l border-[#E3E3E3] top-0"
              style={{ left: '33%' }}
            />{' '}
            <div
              className="absolute h-full border-l border-[#E3E3E3] top-0"
              style={{ left: '66%' }}
            />
          </>
        )}
      </div>
    </FormElementWrapper>
  );
};

export default ThreeColumnLayout;
